import React from "react";

import { Box, Typography } from "@mui/material";

import { PlatformItemProps } from "./type";

export const PlatformItem: React.FC<PlatformItemProps> = ({
  title,
  content,
  FeatureImage,
}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    rowGap={1}
    px={3}
    pt={{ xs: 0, md: 3 }}
    pb={{ xs: 3, md: 4 }}
  >
    <FeatureImage />
    <Typography variant="h5" component="h3" align="center">
      {title}
    </Typography>
    <Typography variant="subtitle1" component="div">
      {content}
    </Typography>
  </Box>
);
